import _loader from '../../components/loader/spinners'
import _http_v1 from '../../http_requests/_http_v1'
import timeline_helper from './helpers/timeline_helper'
import Sidebar from './sidebar/Sidebar';
import '@components/map/full_screen/FullScreen'
import '@components/map/base_map/BaseMap'
import MapScale from './map_scale/MapScale';
import MapCoords from './map_coordinates/MapCoords';
import("../../../styles/components/map/map")

function MapComponent(options){
    this._container = options.container; //obrigatório
    this._map_id = options.map_id; //obrigatório
    this._zoom = options.zoom;
    this._loading = options.loading || {};
    this._map = undefined
    this._basemap = options.basemap
    this._mapScale = options.mapScale
    this._temp_marker = options.temp_marker
    this._lat = options.lat
    this._lng = options.lng
    this._sidebar = options.sidebar
    this._fullscreen = options.fullscreen
    this._mapCoordinates = options.mapCoordinates
    //Obs: Esse objeto foi criando no inicio do desenvolvimento do componente. Hoje eu não vejo finalidade concreta nele (talvez organizacional, mas bem pouca coisa... não justifica)
    //Não vou remove-lo pois estou usando em alguns lugares e pode acabar não sendo tão simples migrar pra lista de camadas padrão do leaflet.
    //A partir do momento que percebi isso, passei a usar a lista de camadas padrão, o que pode dificultar entendimento. (Alguns métodos estão usando uma e outrous outra, whatever xD,se vira)
    //Uma melhoria seria parar de usá-lo :)
    this._layers = {}
    
    //lista de popups do mapa
    let popups = {}

    let temp_marker_options = {
        show: false,
        markable: false
    }

    /**
     * Inicializa um mapa no container informado
     * @param {String} container nome do container do mapa
     * @param {Integer} zoom nível de zoom inicial
     * @returns 
     */
    this.generate = () =>{
        $(this._container).html("<div class='map-container'>");
        $(this._container).find('.map-container').append("<div id='"+this._map_id+"' class='current-map' style='width:100%; height:100%'></div>");
        //$(this._container).append("<div class='map-overlay "+(overlayClass(this._loading.position))+"' "+((!this._loading.show) ? "style='display:none" : "")+">");
        $(this._container).find('.map-container').append("<div class='map-overlay "+(overlayClass(this._loading.position))+"' style='display:none'>"+overlayContent.call(this)+"</div>");
        
        if(this._loading.show){
            this.showOverlay('full')
        }

        let map = L.map(this._map_id,{preferCanvas:true, attributionControl: false,zoomDelta: 0.25,
    zoomSnap: 0.5, wheelPxPerZoomLevel: 200}).setView([this._lat || -22.37, this._lng || -48.55], this._zoom || 10);

        if(this._fullscreen){
            let control = L.control.fullscreen(this._fullscreen).addTo(map)
        }

        this._map = map
        
        //carregando basemaps caso informado na inicialização
        if(this._basemap){
            this.addBaseMap()
        } else {
            //caso não tenha controle de camadas base, carregar a camada padrão do openstreet no mapa
            L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            }).addTo(map);
        }
        
        if(this._temp_marker){
            let context = this
            this.addLayerToMap(new L.featureGroup(), 'temp_marker') //camada para adicionar marker temporário em qualquer lugar no mapa
            this.generateTempMarkerListener()
            
            $(document).on('click', '.location-marker-nearby-markers', e=>{
                let dataset = e.target.dataset
                $(document).trigger('find-location-box:nearby-button::click', {id: dataset.id, lat: dataset.lat, lng: dataset.lng})
            })

            $(document).on('click', '.leaflet-tooltip .btn-copy-coord', e=>{
                let latLng = context.getLayer('temp_marker').pm._layers[0]._latlng
                e.target.innerHTML = 'copiado'
                navigator.clipboard.writeText(`${latLng.lat},${latLng.lng}`);
            }).on('mouseout', '.leaflet-tooltip .btn-copy-coord', e =>{
                e.target.innerHTML = 'copiar'
            })          
            
        }

        if(this._sidebar && this._sidebar.items){
            let sideBarComponent = new Sidebar({container:'.map-container', position: 'left', 
                menu_items:this._sidebar.items,
                map: map,
                open: this._sidebar.open
            })

            sideBarComponent.on('show-content', menuItem=>{
                $(document).trigger('MAP:SIDE-BAR::SHOW_MENU_ITEM', menuItem)
            })
        }

        if(this._mapScale?.position){
            new MapScale({map: map, options: this._mapScale})
        }

        if(this._mapCoordinates?.position){
            new MapCoords({map: map, options: this._mapCoordinates})
        }

        eventsHandler.call(this)
    }
    /**
     * Função para criar um listener de clicks no mapa que analisa se a posição do mouse não se modifica entre o clicar/soltar. (basicamente analisando se NÃO É um evento de drag)
     * o LeafletMap possui sim um listener de evento de 'drag', mas por complicações gerais o nosso listener de click esta sendo colocado no DOMELEMENT _container do mapa. Esse obviamente não tem evento de drag
     * O comportamento esperado é o seguinte: Em caso de click, adicionar/mover o marcador temporario pro local. Em caso de drag, não fazer nada. Em caso de zoom change, não fazer nada
     */

    this.generateTempMarkerListener = () =>{
        let compareMousePosition = () =>{ //função que comparar a posição do click.
            return (mouse_up_event.screenX == mouse_down_event.screenX && mouse_up_event.screenY == mouse_down_event.screenY)
        }
        
        let mouse_up_event,mouse_down_event //variaveis que com o evento de click no mapa

        $(this.getMap()._container).on('mousedown', (e)=>{
            mouse_down_event = e.originalEvent
        })

        $(this.getMap()._container).on('mouseup', (e)=>{
            if(e.target.id == "map" || e.target.nodeName == 'path'){
                mouse_up_event = e.originalEvent
                if(compareMousePosition()){ //compararndo posição do mouse
                    // temp_marker_options.show = true
                    temp_marker_options.markable = true
                } else {
                    // temp_marker_options.show = false
                    temp_marker_options.markable = false
                }
            }
        })
    }

    this.tempMakerHandler = (click_event) =>{
        if(temp_marker_options.markable){
            this.clearLayer('temp_marker')
            if(!temp_marker_options.show){
                let marker = this.generateTempMarker(click_event.latlng)
                this.addLayerToFeature('temp_marker',marker)
                temp_marker_options.show = true
            } else {
                temp_marker_options.show = false
            }     
        }
        temp_marker_options.markable = false
    }


    /**
     * Cria o controle de basemaps no mapa. Cada layer do objeto deve ser composta com os parâmetros 'url, icon, name, attribution, default'.
     * É essencial que uma das layers tenha o parâmetro 'default:true'. Sem uma layer default a biblioteca 'L.basemapsSwitcher' não funciona corretamente.
     */
    this.addBaseMap = () =>{
        new L.basemapComponent(this._basemap.layers
            ,{position: 'bottomleft'}).addTo(this._map)
    }
    /**
     * Adiciona layer ao mapa com identificação
     * @param {LeafletLayer} layer 
     * @param {String} id identificador da camada
     */
    this.addLayerToMap = (layer, id) =>{
        layer.id = id
        if(!this._layers[id]){
            this._map.addLayer(layer)
            this._layers[id] = layer
        }
    }
    /**
     * responds if overlay is current showing
     */
    this.isOverlayShowing =()=>{
        return $(this._container +" .map-overlay").is(':visible')
    }
    /**
     * Caso exista, sera escondida a overlay do mapa
     * @param {String} map_id 
     */
    this.hideOverlay = (data_id) =>{
        if($(this._container +" .map-overlay").attr("id") == data_id){
            $(this._container +" .map-overlay").hide()
            $(this._container +" .map-overlay").attr("id", data_id)
        }
    }
    /**
     * Caso exista e esteja escondida, sera mostrada a overlay do mapa
     * @param {String} map_id 
     */
    this.showOverlay = (data_id) =>{
        if(!this.isOverlayShowing()){
            $(this._container +" .map-overlay").attr("id", data_id)
            $(this._container +" .map-overlay").show()
        }
    }

    this.setOverlayPosition = (position) =>{
        //atualizando options no objeto '_loading'
        this._loading = {...this._loading, position:position}
        //atualizando a overlay atual de acordo com as novas options
        overlayUpdate.call(this)
    }
    /**
     * Adiciona uma layer dentro de uma feature adicionada ao mapa. Por exemplo, adicionar um marker dentro de um FeatureGroup já carregado no mapa.
     * @param {String} layer_id id da feature que receberá a layer. Lembre-se que esse ID foi definido ao adicionar a feature no mapa via MapComponent.addLayerToMap.
     * @param {LeafletLayer} layer LeafletLayer que será adicionada a feature
     */
    this.addLayerToFeature = (feature_id, layer, layer_id) =>{
        let l = this.getLayer(feature_id)
        layer.id = layer_id
        l.addLayer(layer)
    }

    /**
     * Caso exista, layer sera removida do mapa
     * @param {String} layer_id 
     */
    this.removeLayer = layer_id =>{
        if(this._layers[layer_id]){
            this._map.removeLayer(this._layers[layer_id])
            delete this._layers[layer_id]
        }
    }
    /**
     * remove uma layer que esta dentro de um feature/layer
     * @param {String} feature_id id da layer pai
     * @param {String} layer_id  id layer que sera removida do mapa
     */
    this.removeLayerFromFeature = (feature_id, layer_id) =>{
        let f = this.getLayer(feature_id)
        if(f){
            let l = Object.values(f._layers).filter(x=>x.id == layer_id)
            if(l.length > 0){
                l.forEach(x=>this.getMap().removeLayer(x)) 
            }
        }
    }

    /**
     * Remove todas as camadas presentes na layer/feature
     * @param {String} layer_id 
     */
    this.clearLayer = layer_id =>{
        let l = this.getLayer(layer_id)
        if(l){
            l.clearLayers()
        }
    }
    /**
     * Gera um DOM ELEMENT leaflet e insere no mapa na posição informada
     * Gerado com a classe 'dom-element-defataul', que caso queira, possui um estilo definido no arquivo /styles/components/mapa/dom.css. Basta carregar esse arquivo no javascript
     * @param {String} id classe identificadora do elemento
     * @param {String} position posição do elemento no mapa. ex: topright
     * @param {String} html conteudo do elemento
     * @param {Func} func função ao clickar
     */
    this.createDomElement =(id, position, html, funcs, class_list = 'dom-element-default')=>{
        var elem = L.control({position: position});
		elem.onAdd = function (map) {
            var div = L.DomUtil.create('div', class_list + " " +id);
            div.innerHTML += html
            L.DomEvent.disableClickPropagation(div);
            if(funcs){
                $.each(funcs, function(event, f){
                    L.DomEvent.on(div, event, f)
                })
                
            }
            return div;
        };
        elem.addTo(this._map);
        return elem
    }
    /**
     * Método para dar zoom na camada/feature presente no mapa.
     * Caminho da lista de camadas que está sendo analizado: 'this._map._layers' (lista de camadas padrão do leaflet para um mapa)
     * @param {String} layer_id id da camada
     * @returns {Boolean} true caso o zoom seja completo, false caso algum erro aconteça no processo
     */
    this.zoomToLayer = (layer_id) => {
        //obtendo instancia da layer na lista de layers do mapa
        let layer = this.getLayer(layer_id)
        //verificando se a feature existe e se tem alguma layer para método getBounds
        if(layer && this.hasLayers(layer)){
            try{
                //zoom para os limites da camada
                this._map.fitBounds(layer.getBounds())

                return true
            } catch(e){
                //erro desconhecido ao tentar dar o zoom, printando no console
                console.log('Erro ao tentar aproximar da camada', e)

                return false
            }
        } else {
            //layer sem camadas (ex: filtro de markers retornando nenhuma marker), retornando false por conta do 'erro ao dar zoom'
            return false
        }  
    }
    /**
     * Panoramizar até a lat/lng informada
     * @param {LatLng} latLng leaflet LagLng object, ou array lat,lng. ex:[50,30]
     * @param {boolean} animated caso true, será usada uma função diferente, que possui uma animação além da localização
     */
    this.zoomToCoord = (latLng, animated,zoom) => {
        this._map.flyTo(latLng,zoom, {animate:animated})
    }

    this.zoomToFeature = feature =>{
        if(feature.getBounds().isValid()){
            this._map.fitBounds(feature.getBounds())
        }
    }

    this.setLayerStyle = (layer_id, style) =>{
        let layers = Object.values(this._map._layers).filter(x=>x.id == layer_id)
        layers.map(x=>x.setStyle(style))
    }
    /**
     * Retorna a layer/feature presente no mapa com o ID 
     * @param {String} layer_id 
     * @returns {LeafletLayer} ou undefined
     */
    this.getLayer = (layer_id) =>{
        let layer = Object.values(this._map._layers).filter(x=>x.id == layer_id)
        if(layer != []) {
            return layer[0]
        } else {
            throw "Camada não localizada - " + layer_id
        } 
    }
    this.hasLayers = (feature)=>{
        return feature.getLayers().length > 0
    }

    this.getMap = () =>{
        return this._map
    }
    /**
     * Mapas Leaflet possuem apenas 4 posições para 'leaflet-control' inclusas [bottomleft, bottomright, topleft, topright]
     * Esse método adiciona uma nova posição para o mapa, com auxilio de css, acaba fixando em qualquer lugar do mapa
     * O comportamento esperado, é que uma nova 'div' dentro de '.leaflet-control-container' seja criada
     * @param {String} vside 'verticalSide': nome da 'primeira parte' da nova posição. ex: 'top'
     * @param {String} hside 'horizontalSide': nome da 'segunda parte' da nova posição. ex: 'middle'
     */
    this.addCustomPositionToMap = (vside, hside) => {
        var corners = this._map._controlCorners,
            l = 'leaflet-',
            container = this._map._controlContainer;
    
        function createCorner(vSide, hSide) {
            var className = l + vSide + ' ' + l + hSide;
    
            corners[vSide + hSide] = L.DomUtil.create('div', className, container);
        }
        createCorner(vside, hside);
    }
    /**
     * Recebe uma lista de markers e retorna um clusterGroup deles
     */
    this.markersToCluster =(markers, clusterOptions = {})=>{
        let cluster_markers = L.markerClusterGroup(clusterOptions);
        $.each(markers, function(index, marker){
            cluster_markers.addLayer(marker);
        })
        return cluster_markers
    }

    this.getNearbyMarkers = (latLng, radius) =>{
        let markers = []
        $.each(this.getLayer('markers').getLayers(), (index,marker)=>{
            //diferença entre o centro do circulo e o marcador
            let diff = this.getMap().distance(marker.getLatLng(), latLng);
            
            //verificando se o marker esta dentro do circulo
            let isInside = diff < radius;

            if(isInside){
                markers.push(marker)
            }
        })
        return markers
    }

    this.getWithinMarkers = layer =>{
        //lib 'PointInPolygon' adicionada via yarn
        let markers = []
        $.each(this.getLayer('markers').getLayers(), (index,marker)=>{
            let isInside = layer.contains(marker.getLatLng())
            if(isInside){
                markers.push(marker)
            }
        })
        return markers
    }

    this.generateTempMarker = latLng =>{
        let context = this
        var myIcon = L.divIcon({className: 'temp-marker-icon', html: '<i class="fas fa-map-marker-alt"></i>'});
        let marker = L.marker(latLng, {icon:myIcon})
        let tooltip = L.tooltip({permanent:true, offset: new L.Point(15,5), interactive:true, type:'tooltip'}).setContent(generateTempMarkerTooltipContent(latLng, context._temp_marker.tooltip_content))
        if(this._temp_marker.show_tooltip){
            marker.bindTooltip(tooltip);
        }
        
        return marker
    }

    this.addPopup = (id, latLng, content) =>{
        popups[id] = L.popup().setLatLng(latLng).setContent(content)
        // popups[id] = L.popup()
    }
    this.setPopupLatLng = (id, latLng) => {
        popups[id].setLatLng(latLng)
    }
    this.getPopup = (id) =>{
        return popups[id]
    }
    this.openPopup = (id) =>{
        popups[id].openOn(this._map)
    }
    this.closePopup = (id) =>{
        popups[id]._close()
    }



    //Método para carregar e adicionar ao mapa a camada de limite estadual
    //Como é usado em DIVERSOS produtos do SIBH, vale a pena deixar aqui como helper
    //Adiciona ao mapa uma layer FeatureGroup com o id parametrizado, não precisa criar uma préviamente
    //O limite sera adicionado DENTRO da featureGroup
    /**
     * 
     * @param {String} layer_id id do featureGroup 'pai' da camada
     * @param {Boolean} simplified se a camada sera a versão simplificada ou não
     * @returns 
     */
    this.addStateLimitToMap = (layer_id, feature_style={}, request_options={}) =>{
        let context = this
        
        // //adicionando state_limit ao mapa
        this.addLayerToMap(new L.featureGroup(), layer_id)

        return new Promise((resolve, error)=>{
            this.getStateLimitFeature(request_options).then(featureGroup=>{
                context.addLayerToFeature(layer_id,featureGroup)
                resolve()
            })
        })
    }

    /**
     * Retorna uma promise que tem como resultado a featureGroup da layer do Limite estadual
     * @param {Object} request_options opções da request
     * @returns Promise
     */
    this.getStateLimitFeature = (request_options={}) =>{
        return new Promise((resolve, error)=>{
            _http_v1.request('maps/state_limit', 'GET', request_options).then(data=>{
                let featureGroup = L.featureGroup().addLayer(L.geoJson(JSON.parse(data[0].geometry_json), {
                    onEachFeature: function (feature, l) {
                        l.setStyle({color: '#4a4b65',weight:2, fill:false});
                    }
                }))
                resolve(featureGroup)
                // context.addLayerToFeature(layer_id,featureGroup)
            })
        })
    }

    this.addCityLimitToMap = (layer_id, feature_style={}, request_options={}) =>{
        let context = this
        
        // //adicionando state_limit ao mapa
        this.addLayerToMap(new L.featureGroup(), layer_id)

        return _http_v1.request('maps/city_limit', 'GET', request_options).then(data=>{

            data.forEach(line=>{                    
                //convertendo a camada em um geoJSON
                let layer = L.geoJSON(JSON.parse(line.geometry_json), feature_style) 
                
                //adicionando camada de intensidade na camada de secas no mapa
                context.addLayerToFeature(layer_id,layer)
            })
        })

    }

    /**
     * Adiciona uma feature com os limites disponiveis na API de mapas no mapa atual. Exemplos: Estadual, Municipal, Ugrhi, etc.
     * @param {String} layer_id nome da layer que sera inserido o featureGroup do limite. Se a layer não existir no mapa, sera criada. Layer criada será um featureGroup
     * @param {String} limit_type Tipo do limite que será adicionado. Ex: ugrhi, city, state
     * @param {Object} feature_style Objeto com o estilo que sera usado no eachFeature
     * @param {Object} request_options Request Options caso tenha
     * @returns {Promise} promise que será resolvida quando o featureGroup já estiver sido adidicionado ao mapa
     */
    this.addLimitToMap = (layer_id, limit_type, feature_style={}, request_options={}) => {
        let context = this
        this.addLayerToMap(new L.featureGroup(), layer_id)
        return new Promise((resolve, fail)=>{
            this.getLimitFeature(limit_type, request_options,feature_style).then(featureGroup=>{
                context.addLayerToFeature(layer_id,featureGroup)
                resolve(featureGroup)
            })
        })
    }
    /**
     * Método que busca no database a geometria de um limite (estadual, municipal, etc..) e retorna um cria um featureGroup da mesma.
     * @param {String} limit_type Tipo do limite que será buscado. Ex: ugrhi, city, state
     * @param {Object} request_options Request Options caso tenha
     * @returns {Promise} promise que será resolvida quando o featureGroup for montada. Retorna a featureGroup como parametro
     */
    this.getLimitFeature = (limit_type, request_options,feature_style) =>{
        return this.getJSONlimit(limit_type, request_options).then(json_data=>{
            return this.JSONtoFeature(json_data, limit_type, feature_style)
        })
    }

    this.getJSONlimit = (limit_type, request_options) =>{
        let url = `maps/${limit_type}_limit`
        // return new Promise((resolve, error)=>{
        return _http_v1.request(url, 'GET', request_options)
        // })
    }

    this.JSONtoFeature = (JSON_data,limit_type, feature_style) =>{
        let featureGroup = new L.featureGroup()
        JSON_data.forEach(line=>{                    
            //convertendo a camada em um geoJSON
            let layer = L.geoJSON(JSON.parse(line.geometry_json), feature_style) 
            
            //nao deveria estar,mas outros produtos usam, nao tirar
            if(limit_type == 'ugrhi' || limit_type == 'subugrhi'){
                layer.codigo = line.codigo
                layer.nome = line.nome
            }
            if(limit_type == 'city'){
                layer.cod_ibge = line.cod_ibge
                layer.name = line.name
            }
            layer.obj_prop = line
            layer.defaultStyle = feature_style
            //adicionando camada de intensidade na camada de secas no mapa
            featureGroup.addLayer(layer)
        })
        featureGroup.getLayers().forEach(layer=>{
            layer.setStyle(feature_style)
        })
        return featureGroup
    }


    this.getStationsFeature = async (url_params, request_options={}, icon_options ={}) =>{
        let featureGroup = new L.featureGroup()
        return _http_v1.request(`station_prefixes/simplify?${url_params || ''}`, 'GET',request_options).then(stations=>{
            let icon = L.divIcon({className: `map-component-default-icon ${icon_options.klass || ''}`});
            stations.forEach(station=>{
                let marker = new L.marker([station.station.latitude, station.station.longitude], {icon:icon})
                marker.obj_prop = station
                featureGroup.addLayer(marker)
            })
            return featureGroup
         
        })
    }

    this.addTimelineRadarDaeeToMap = async () =>{
        const TimelineControl = await import('./timeline_control/TimelineControl');

        let states = await timeline_helper.getDaeeRadarStates(20)

        let timelineControl = new TimelineControl.default({
            map:this.getMap(), 
            states:states,play:false,
            options:{contentType:'imageOverlay', imageBounds:{}, speed: 2}
        })
        
        timelineControl.generate()
    }

    this.addTimeLineTo

    this.getCurrentZoom = _ =>{
        return this.getMap().getZoom();
    }

    this.setMaxZoom = value =>{
        this.getMap().setMaxZoom(value)
    }

    this.setMinZoom = value =>{
        this.getMap().setMinZoom(value)
    }

    this.setZoom = value =>{
        this.getMap().setZoom(value)
    }

    function generateTempMarkerTooltipContent(latLng, content_options){
        // let html = "<div>"+latLng.lat.toFixed(5) + ", " +latLng.lng.toFixed(5)+"</div>"
        let html = `<div>${latLng.lat.toFixed(5)}, ${latLng.lng.toFixed(5)} ${ (content_options.copy_button) ? '<button type="button" class="btn-copy-coord">copiar</button>' : "" }</div>`

        if(content_options.copy){
            html += "<div>Copiar</div>"
        }

        if(content_options.closest_stations){
            html += "<div class='mt-2'>Selecionar próximos</div>";

            [1,2,5,10].forEach(n=>{
                html += "<button class='location-marker-nearby-markers' data-lat="+latLng.lat+" data-lng="+latLng.lng+" data-id="+n+" type='button'>"+n+" km</button>"
            })
        }        

        if(content_options.distance){
            html += "<div class='mt-2'><button type='button' data-lat="+latLng.lat+" data-lng="+latLng.lng+" class='location-marker-tooltip-button-distance'>Ver distância</button></div>"
        }

        html += "</div>"
        return html
    }

    function overlayClass(position){
        switch(position){
            case 'full':
                return "map-overlay-full"
            case 'top-right':
                return "map-overlay-top-right";
            case 'top-left':
                return "map-overlay-top-left";
            default:
                return 'map-overlay-full'
        }
    }
    function overlayContent(){
        let type = (this._loading && this._loading.spinner_type) ? this._loading.spinner_type : "1"
        let color = (this._loading && this._loading.spinner_color) ? this._loading.spinner_color : "rgba(0,0,0,0.5)"
        let size = (this._loading && this._loading.spinner_size) ? this._loading.spinner_size : ""
        return _loader.defaultSpinner(type, color, size)
    }
    /**
     * atualizando overlay de acordo com as propriedades atuais dentro de '_loading'
     */
    function overlayUpdate(){
        //instancia do elemento overlay
        let elem = $(this._container).find('.map-container').find('.map-overlay')
        //removendo todas as classes do elemento
        $(elem).removeClass()
        //adicionando classes de acordo com as options
        $(elem).addClass('map-overlay ' +overlayClass(this._loading.position))
    }

    function eventsHandler(){
        this.getMap().on('click', (e)=>{
            if(this._temp_marker){
                this.tempMakerHandler(e)
            }
        })
    }
}

window.MapComponent = MapComponent